import BaseViewController from "./base-view-controller";

class ConsultationListViewController extends BaseViewController {
  formState = {};

  prepareSubmit(values) {
    return { ...values, ...this.formState };
  }

  handleButtonClick(name, text, action) {
    const {
      values: { logged_in_member_id },
      fetchFlow
    } = this.appData;
    if (name === "speakToDoctorButton") {
      fetchFlow({
        url: "/screens/request_consult/start",
        formState: { logged_in_member_id }
      });
      return;
    }
    if (name === "selectedData") {
      this.formState = { ...text };
    }
    super.handleButtonClick(name, text, action);
  }
}

export default ConsultationListViewController;
